import type {Result, UseCase} from 'framework';
import type {AuthRepository, SignUpWithEmailData} from '../ports/auth.repository';
import type {Session} from '../../domain/session';
import type {SignUpError} from '../../domain/errors';

export class SignUpWithEmail implements UseCase<[SignUpWithEmailData], Session> {
  constructor(private readonly authRepository: AuthRepository) {}

  execute(data: SignUpWithEmailData): Promise<Result<Session, SignUpError>> {
    return this.authRepository.signUpWithEmail(data);
  }
}
